module.exports = __webpack_public_path__ + "static/media/play-icon-white.826b5692.svg";